import { useState } from "react";
import { Trash } from "@phosphor-icons/react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export default function ConfirmDelete({ label, title, description, onConfirm, testid }) {
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  };
  return <AlertDialog>
    <AlertDialogTrigger asChild>
      <button data-testid={testid} className="inline-flex items-center gap-2 border-2 border-destructive text-destructive font-bold uppercase tracking-wide text-sm px-4 py-3 rounded-md hover:bg-destructive hover:text-white transition-colors">
        <Trash size={16} weight="bold"/> {label}
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent data-testid={`${testid}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testid}-cancel`}>Keep it</AlertDialogCancel>
        <AlertDialogAction data-testid={`${testid}-confirm`} onClick={run} disabled={busy} className="bg-destructive text-white hover:bg-destructive/90">
          {busy ? "Deleting…" : "Yes, delete"}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
}
